import { Component, inject, OnInit } from '@angular/core';
import { GestionProvenanceService } from '@services/navigation/gestion-provenance.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-bouton-retour-parcours-externe',
  templateUrl: './bouton-retour-parcours-externe.component.html',
  standalone: false,
})
export class BoutonRetourParcoursExterneComponent implements OnInit {
  private readonly gestionProvenanceService = inject(GestionProvenanceService);

  urlRetourParcoursExterne!: string | null;
  libelleParcoursExterne: BehaviorSubject<string> = new BehaviorSubject<string>('bouton.retour');

  ngOnInit() {
    this.urlRetourParcoursExterne = this.gestionProvenanceService.obtenirRouteExterne();
    this.libelleParcoursExterne = this.gestionProvenanceService.obtenirLibelleProvenance();
  }
}
